import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Divider, Layout } from 'antd';
import {LaunchRounded} from "@mui/icons-material";
import { selectUserFields } from '../../Store/slices/user.slice';
import PortfolioCollectionTable from './PortfolioCollectionTable/PortfolioCollectionTable';
import PageHeader from '../../Components/PageHeader';
import { iconMapping } from '../../Configs/AppsConfig';
import { countPortfoliosWithSignals } from './PortfolioCollectionTable/utils';
import PortfolioPageCard from "./PortfolioPageCard";
import GraphicChip from "../../Components/GraphicChip";
import {selectPortfoliosWithUserUpdates} from "../../Store/slices/portfolios.slice";

const PortfolioCollection = () => {
    const items = useSelector(selectPortfoliosWithUserUpdates);

    const navigate = useNavigate();
    const portfolioPrefix = useSelector((state) => selectUserFields(state, 'settings.portfolio_prefix'));

    const formattedPortfolios = React.useMemo(() => {
        return items.map((portfolio) => ({
            ...portfolio,
            inceptionDate: new Date(portfolio.inception_date * 1000).toLocaleDateString(),
        }));
    }, [items]); // Include updateFlag to trigger re-calculation when flag toggles


    return (
        <>
          <PageHeader
            title={'Portfolios'}
            logoUrl={iconMapping.portfolios}
            actions={[
              <Divider type={'vertical'} />,
            ]}
          />
          <Layout>
            <Layout.Content style={{
                padding: '24px 48px',
            }}>
              {formattedPortfolios.length > 0 && (
                <PortfolioCollectionTable
                  portfolios={formattedPortfolios}
                  prefix={portfolioPrefix}
                />
              )}
            </Layout.Content>
            <Layout.Sider
                className={'full right white'}
                width={264}
                style={{paddingTop: '10px', background: "#fff"}}
            >
              <div className={'mono-text px-3'}>More Apps to Explore through your Portfolios</div>
              <Divider/>
              <PortfolioPageCard />
              <Divider/>
              <GraphicChip
                    imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/library/graphic-photo/stock-charts--line-area/blue-net.jpeg'}
                    title="New Signals"
                    tag={
                      formattedPortfolios.length > 0
                        ? countPortfoliosWithSignals(formattedPortfolios)
                        : 0
                    }
                    icon={<LaunchRounded style={{ fontSize: '18px' }} />}
                    onClick={()=>navigate('/signals')}
                    overlay={'rgba(13, 42, 76, 0.3)'}
                    tagColor={'rgba(254, 28, 55, 1)'}
                    tagWeight={'600'}
                    showIcon={true}
              />

            </Layout.Sider>
          </Layout>
        </>
  );
};

export default PortfolioCollection;